import ModalWithChildren from "./modal-with-children";

export default ModalWithChildren;
